// src/loaders/autoLoginLoader.js

import authConfig from 'config/auth';
import { loginUser } from '@fake-db/auth/jwt';
const PUBLIC_URL = process.env.PUBLIC_URL;

export async function autoLoginLoader({ request }) {
  const url = new URL(request.url);

  // Retrieve query parameters
  const mobile = url.searchParams.get('user_phone');
  const password = url.searchParams.get('user_pin');

  try {
    const [status, response] = await loginUser(mobile, password);
    if (status === 200) {
      window.localStorage.setItem(
        authConfig.storageTokenKeyName,
        response.accessToken
      );
      const loginTime = new Date();

      window.localStorage.setItem(
        'kerpUserData2.1',
        JSON.stringify({ ...response.userData, loginTime: loginTime })
      );
      // JSON.stringify({ ...response.userData, loginTime })
      window.localStorage.setItem('krpLogin', true);
      window.localStorage.setItem('loginInMobileApp', true);
      window.location.assign(`${PUBLIC_URL}/`);

      return 'login success';
    } else if (status === 403) {
      // Handle permission error
      throw new Response('Unauthorized', { status: 403 });
    } else {
      throw new Response('Server Error', { status: 300 });
    }
  } catch (error) {
    throw new Response('Server Error', { status: error.status });
  }
}
